import React from 'react';
import { Link } from 'react-router-dom';

const BackEndFooter = () => {
  return(
  <>
    <footer className='footer mt-5 mb-3'>
      <div className='container-fluid'>
        <div className='row align-items-center'>
          <div className='col-sm-6 text-center text-sm-start mb-2 mb-sm-0'>
            <p className='mb-0 text-muted'>
              &copy; {new Date().getFullYear()} Pandus Powell’s LTD. All Rights Reserved.
            </p>
          </div>
          <div className='col-sm-6 text-center text-sm-end'>
            <ul className='list-inline mb-0'>
              <li className='list-inline-item'>
                <Link to='/about' className='text-muted'>About</Link>
              </li>
              <li className='list-inline-item'>
                <Link to='/support/my-tickets' className='text-muted'>Support</Link>
              </li>
              <li className='list-inline-item'>
                <Link to='/contact' className='text-muted'>Contact</Link>
              </li>
              <li className='list-inline-item'>
                <a
                  href='https://omimek.com'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-muted'
                >
                  Developed by Omimek Technology
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </>
  )
}

export default BackEndFooter;
